"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var weighted_random_index_1 = __importDefault(require("pandemonium/weighted-random-index"));
/**
 * Randomly choose from a set of options.  Weight the choice by the value of each option.
 * For example, for options [3, 1] the first option is 3x more likely to be chosen.
 * @param weights The options to choose from
 * @returns The 0-based index of the selected option
 */
function chooseRandomWeight(weights) {
    return weighted_random_index_1["default"](weights);
}
exports["default"] = chooseRandomWeight;
//# sourceMappingURL=weighted-random.js.map